export const INVALID_SIGNATURES_BANNER = 'invalidSignaturesBanner';
export const INVALID_SIGNATURES_FILTER_LOCAL_STORAGE_KEY =
    'rolesWithInvalidSignatures';
